<template>
    <div class="container-side">
        <div class="title-side"></div>
        <div class="wrapper-btn-side">
            <div class="box-menu" v-for="(data,index) in sideMenu" :key="`sideMenu${index}`">
                <div class="top-menu" @click="toggleMenu(data,index)" :id="`topMenu${index}`" :class="[{'active':activeMenu(data)},{'open':openTopMenu.includes(index)}]">
                    <div class="img-top-menu" :class="data.meta.name"></div>
                    <div class="text-top-menu">{{ data.meta.title }}</div>
                </div>
                <div class="wrap-sub-menu" :id="`subMenu${index}`">
                    <button class="btn-sub-menu" v-for="(sub,index) in returnChild(data.children)" :class="{'active':activeSub(data,sub)}" @click="moveSubPage(data,sub)" :key="`subMenu${index}`">
                        {{ sub.meta.title }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from '@/mixins/util'

export default {
    name: "SideMenu",
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            sideMenu: [],
            openTopMenu: [],
        };
    },
    created() {

    },
    mounted() {
        this.setMenu()
    },
    beforeUnmount() {},
    unmounted(){},
    computed: {},
    methods: {
        activeMenu(data) {
            let path = "/" + this.$route.path.split('/')[1]
            return data.path === path;
        },

        returnChild(data) {
            let subArr = data.filter(data => data.meta && !data.meta.sideHidden)
            if (!util.isEmpty(data)) {
                return subArr
            }
        },


        toggleMenu(data, index) {
            let foundIndex = this.openTopMenu.indexOf(index);
            if (foundIndex !== -1) {
                this.openTopMenu.splice(foundIndex, 1);
            } else {
                this.openTopMenu.push(index);
            }
            this.openSubMenu(index)
        },
        openSubMenu(index) {
            if (index === 'first') {
                for (let i = 0; i < this.openTopMenu.length; i++) {
                    let subMenu = document.getElementById(`subMenu${i}`)
                    if (subMenu) {
                        subMenu.style.height = subMenu.scrollHeight + 'px';
                    }
                }
            } else {
                let subMenu = document.getElementById(`subMenu${index}`)
                if (subMenu) {
                    if (this.openTopMenu.includes(index)) { // index가 openTopMenu에 포함되어 있는지 확인
                        subMenu.style.height = subMenu.scrollHeight + 'px';

                    } else {
                        subMenu.style.height = '0px';
                    }
                }
            }
        },
        activeSub(data, sub) {
            let path = this.$route.path.split('/')
            if ('/' + path[1] +path[2] === data.path + sub.path) {
                return true
            }
        },
        moveSubPage(data, sub) {
            let route = data.path + '/' + sub.path
            this.$router.push(route)
        },

        setMenu() {
            this.sideMenu = this.$router.options.routes.filter(data => data.children)
        },
    },
    watch: {}
};
</script>

<style lang="scss"></style>
